import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { tv } from 'tailwind-variants';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Input } from '@/components/ui/input/input.component';

export const inputStyle = tv({
  base: 'pointer-events-none',
});

export function SearchInput({ className }: { className?: string }) {
  const style = inputStyle({ className });

  return (
    <Input
      placeholder="Buscar por especialidades, exames e profissionais"
      startIcon={faSearch}
      startIconStyle="text-green-500 text-xl"
      className={style}
      value=""
      data-testid={DataTestIdEnum.SEARCH_INPUT_PROCEDURES_MODAL}
    />
  );
}
